import { useState } from 'react'
import { Outlet } from 'react-router-dom'
import { TopNav } from './TopNav.tsx'
import { SideNav } from './SideNav.tsx'
import { ErrorBoundary } from '../ui/ErrorBoundary.tsx'

export function AppLayout() {
  // Collapse sidebar by default on small screens — avoids eating content width on mobile
  const [sideNavCollapsed, setSideNavCollapsed] = useState(() => window.innerWidth < 768)

  return (
    <div className="flex flex-col h-screen bg-surface-base overflow-hidden">
      <TopNav />
      <div className="flex flex-1 overflow-hidden">
        <SideNav
          collapsed={sideNavCollapsed}
          onToggle={() => setSideNavCollapsed(v => !v)}
        />
        <main className="flex-1 overflow-auto">
          <ErrorBoundary>
            <Outlet />
          </ErrorBoundary>
        </main>
      </div>
    </div>
  )
}
